module.exports = __webpack_public_path__ + "img/prt.b908edae.svg";